import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from './dialog';
import { Button } from './button';
import { Trash2, Loader2 } from 'lucide-react';

interface DeleteConfirmationDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  title?: string;
  description?: string;
  isDeleting?: boolean;
}

export const DeleteConfirmationDialog: React.FC<DeleteConfirmationDialogProps> = ({
  isOpen,
  onOpenChange,
  onConfirm,
  title = 'Are you sure?',
  description = 'This action cannot be undone. This will permanently delete the selected item.',
  isDeleting = false,
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-3xl border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 shadow-2xl max-w-sm">
        <DialogHeader className="flex flex-col items-center text-center space-y-4 pt-4">
          <div className="bg-rose-50 dark:bg-rose-950/50 p-4 rounded-full border-8 border-rose-50/50 dark:border-rose-950/20">
            <Trash2 className="h-8 w-8 text-rose-500 dark:text-rose-400" />
          </div>
          <div className="space-y-1">
            <DialogTitle className="text-xl font-extrabold text-slate-800 dark:text-slate-100 text-center">
              {title}
            </DialogTitle>
            <DialogDescription className="text-slate-500 dark:text-slate-400 font-medium text-sm text-center px-2">
              {description}
            </DialogDescription>
          </div>
        </DialogHeader>
        <DialogFooter className="flex flex-row items-center justify-center gap-3 w-full pt-4 pb-2 sm:justify-center">
          <Button
            variant="outline"
            disabled={isDeleting}
            onClick={() => onOpenChange(false)}
            className="rounded-xl font-bold h-11 border-slate-200 dark:border-slate-800 text-slate-700 dark:text-slate-300 flex-1"
          >
            Cancel
          </Button>
          <Button
            onClick={onConfirm}
            disabled={isDeleting}
            className="bg-rose-500 hover:bg-rose-600 dark:bg-rose-600 dark:hover:bg-rose-700 text-white font-bold h-11 rounded-xl shadow-md border-none flex-1"
          >
            {isDeleting ? (
              <><Loader2 className="h-4 w-4 mr-2 animate-spin" /> Deleting...</>
            ) : (
              'Delete'
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
